import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DeleteEventDialog = ({ visible, onHide, onDelete }) => {
    const deleteDialogFooter = (
        <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={onDelete} />
        </>
    );

    return (
        <Dialog
            visible={visible}
            header="Delete Event"
            modal
            footer={deleteDialogFooter}
            onHide={onHide}
            className="event-delete-dialog frazza-dialog-sm"
        >
            <div className="event-delete-confirmation">
                <div className="frazza-alert-icon warning">
                    <i className="pi pi-exclamation-triangle" />
                </div>
                <div className="frazza-alert-content">
                    <h4 className="frazza-alert-title">Are you sure?</h4>
                    <p className="frazza-alert-message">This event will be permanently deleted. This action cannot be undone.</p>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteEventDialog;